import {
  BreadcrumbItem,
  BreadcrumbLabel,
  BreadcrumbList,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  TabsHeader
} from '@criteria-labs/react'
import { Service } from '@criteria-labs/docs-kit'
import { InspectorArticle, InspectorHeader } from '../article'
import { ServiceAuthentication } from './ServiceAuthentication'
import { ServiceEndpoints } from './ServiceEndpoints'
import { ServiceOverview } from './ServiceOverview'
import { ServiceResources } from './ServiceResources'

export function ServiceDetail({ service }: { service: Service }) {
  return (
    <InspectorArticle>
      <Tabs>
        <InspectorHeader className="space-y-3">
          <BreadcrumbList className="min-h-10">
            <BreadcrumbItem>
              <BreadcrumbLabel>API</BreadcrumbLabel>
            </BreadcrumbItem>
          </BreadcrumbList>
          <TabsHeader className="flex items-baseline gap-x-6">
            <Heading>{service.title ?? 'API'}</Heading>
            <TabList>
              <Tab>Overview</Tab>
              <Tab>Resources</Tab>
              <Tab>Endpoints</Tab>
              <Tab>Authentication</Tab>
            </TabList>
          </TabsHeader>
        </InspectorHeader>
        <TabPanels>
          <TabPanel className="space-y-6">
            <ServiceOverview service={service} />
          </TabPanel>
          <TabPanel>
            <ServiceResources service={service} />
          </TabPanel>
          <TabPanel>
            <ServiceEndpoints service={service} />
          </TabPanel>
          <TabPanel>
            <ServiceAuthentication service={service} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </InspectorArticle>
  )
}
